import { PhosphorTrashButton } from "components/Atoms/PhosphorIconButton";
import Tag from "components/Tag/Tag";
import moment from "moment";
import React from "react";
import { formatShortDate } from "utilities";
import { routes } from "utilities/routing/generatedRoutes";
import { compareLanguages } from "utilities/translationUtils";

interface Props {
  article: server.dto.Article
  onDelete: (article: server.dto.Article) => void;
}

const ArticleRow = (props: Props) => {
  const { article, onDelete } = props;
  return <div className="gray-100 flex padding gap">
    <div style={{ width: 100 }}>
      {article.listImage && <img src={article.listImage} style={{ width: 100 }} />}
    </div>
    <div className="grow1">
      <div>
        <div className="flex gap">
          <a href={routes.article_Detail(article.articleId).absolute}>{article.internalTitle}</a>

          {!article.isPublished && <Tag color="red" label="Unpublished" />}
        </div>

        <div className="small">
          {formatShortDate(moment.utc(article.publication))}
        </div>

        <div className="small">
          {article.translations.sort((a, b) => compareLanguages(a.language, b.language)).map((translation) => translation.language).join(", ")}
        </div>

        <div className="smaller">
          id : {article.articleId}
        </div>
      </div>
    </div>
    <div>
      <span className="small">{article.categories.map(c => c.englishTitle).join(", ")}</span>
    </div>
    <PhosphorTrashButton
      layout="in-square"
      onClick={() => onDelete(article)} />
  </div>
}



export default ArticleRow;